import React from "react";

const navigation = [
  { name: "Home", href: "/#hero-section" },
  { name: "Services", href: "/#services" },
  { name: "Why Choose", href: "/#features" },
  // { name: "Developers", href: "#" },
];

const Footer: React.FC = () => {
  return (
    <footer className="relative overflow-hidden">
      <div className="relative z-10 container mx-auto px-6 py-24">
        <img
          className="absolute bottom-0 left-0"
          src="/assets/images/radial2.svg"
          alt="..."
        />
        <div className="flex flex-wrap -m-6 relative">
          <div className="w-full md:w-1/2 lg:w-5/12 p-6">
            <div className="flex flex-col justify-between h-full max-w-sm">
              <div className="mb-11">
                <img
                  className="h-16 w-auto"
                  src="/assets/images/logo.png"
                  alt="..."
                />
              </div>
              <div>
                <p className="mb-14 text-gray-200 text-sm">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pretium dui convallis sagittis tempus mi viverra eget. Quisque
                  justo, blandit orci.
                </p>
                <p className="text-gray-400 text-sm">
                  © Copyright 2024. All Rights Reserved by Soft Stake.
                </p>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-2/12 p-6 ml-auto">
            <div className="h-full">
              <h3 className="mb-7 font-heading font-bold text-base text-white tracking-px">
                Quick Links
              </h3>
              <ul className="space-y-4">
                {navigation.map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="nav-link capitalize">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-2/12 p-6">
            <div className="h-full">
              <h3 className="mb-7 font-heading font-bold text-base text-white tracking-px">
                Social media
              </h3>
              <ul>
                <li className="mb-4">
                  <a className="nav-link capitalize" href="!#">
                    Twitter
                  </a>
                </li>
                <li className="mb-4">
                  <a className="nav-link capitalize" href="!#">
                    Discord
                  </a>
                </li>
                <li>
                  <a className="nav-link capitalize" href="!#">
                    Linkedin
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
